<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [model]="model"
  [noSubmit]="true"
  [columns]="orignalColumns"
  (cancelChange)="cancel()">
  <ng-container class="content">
    <kgrid
      [label]="label"
      [name]="apiName"
      pathPreFix="INV"
      [dataList]="dataList"
      [columns]="columns"
      [noToolBar]="true"
      [groupable]="false"
      [filtering]="false"
      [paging]="false"
      [isAdd]="false"
      [isEdit]="false"
      [isDelete]="false">
    </kgrid>
  </ng-container>
</dynamic-form>
